export enum PlanOfCareReviewStatusEnum {
  InProgress = 1,
  Returned = 2,
  Approved = 3
}

export const PlanOfCareReviewStatusOptions = [
{ id: 1, label: 'In Progress' },
{ id: 2, label: 'Returned' },
{ id: 3, label: 'Approved' }
];
